<template>
  <v-dialog
    :model-value="modelValue"
    :max-width="maxWidth"
    persistent
    scrollable
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card rounded="lg">
      <v-card-title v-if="title" class="text-h6 font-weight-bold text-primary">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="message" class="text-body-2 py-0" style="white-space: pre-line">
        {{ message }}
      </v-card-text>
      <v-card-actions class="px-4 pb-4 pt-4">
        <v-spacer />
        <v-btn variant="outlined" size="small" :disabled="loading" @click="onCancel">
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="confirmColor"
          variant="elevated"
          :loading="loading"
          size="small"
          @click="onConfirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Diálogo de confirmación reutilizable (Vuetify 3), alineado al uso de ConfirmDialog en geclisa-site.
 */
export default {
  name: 'ConfirmDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Aceptar',
    },
    cancelText: {
      type: String,
      default: 'Cancelar',
    },
    maxWidth: {
      type: [String, Number],
      default: 480,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmColor: {
      type: String,
      default: 'primary',
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  methods: {
    onCancel() {
      this.$emit('update:modelValue', false)
      this.$emit('cancel')
    },
    onConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
